import React, {useState} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import * as api from "../../apis/productOutside";
import useAntTable from "../../utils/useAntTable";
import PictureColumn from "../quotation-progress/pictureColumn";
import {Button, message, Space} from "antd";
import UploadModal from "../../components/UploadModal";
import {useRequest} from "ahooks";


function ProductOutside() {

    const {tableProps} = useAntTable(api.getProducts, {})

    const [importModalVisible, setImportModalVisible] = useState(false)

    async function update() {
        await api.updateProductFromPink()
        message.success("Submit successfully")
    }

    const {run: onImport, loading: onImporting} = useRequest(api.importProducts, {
        manual: true,
        onSuccess: (response) => {
            window.location.reload()
        }
    })

    const columns: StandardColumnsType = [
        {
            dataIndex: 'code',
            title: 'Code',
            search: true
        },
        {
            dataIndex: 'name',
            title: 'Name',
            search: true
        },
        {
            dataIndex: 'category',
            title: 'Category',
            search: true
        },
        {
            dataIndex: 'series',
            title: 'Series Name',
        },
        {
            dataIndex: 'photo',
            title: 'Picture',
            render: value => (<PictureColumn>{value}</PictureColumn>)
        },
        {
            dataIndex: 'texture',
            title: 'Texture Picture',
            render: value => (<PictureColumn>{value}</PictureColumn>)
        },
        {
            dataIndex: 'height',
            title: 'Height(mm)',
        },
        {
            dataIndex: 'width',
            title: 'Width(mm)',
        },
        {
            dataIndex: 'depth',
            title: 'Depth(mm)',
        },
        {
            dataIndex: 'material',
            title: 'Material',
        },
        {
            dataIndex: 'price',
            title: 'Price',
        },
        {
            dataIndex: 'originPlace',
            title: 'Place of Origin',
        },
        {
            dataIndex: 'netWeight',
            title: 'Net Weight(kg)',
        },
        {
            dataIndex: 'exportable',
            title: 'Exportable',
        },
        {
            dataIndex: 'packing',
            title: 'Packing',
        },
        {
            dataIndex: 'cartonSize',
            title: 'Carton Size(cm)',
        },
        {
            dataIndex: 'grossWeight',
            title: 'Gross Weight(kg)',
        },
        {
            dataIndex: 'brand',
            title: 'Brand',
        },
        {
            dataIndex: 'market',
            title: 'Market',
        },
        {
            dataIndex: 'unit',
            title: 'Unit',
        },
        {
            dataIndex: 'containsWood',
            title: 'Contains Wood',
            render: (value) => value ? 'Y' : 'N'
        },
        {
            dataIndex: 'fsc',
            title: 'FSC',
            render: (value) => value ? 'Y' : 'N'
        },
        {
            dataIndex: 'supplierCommodityInspection',
            title: 'Supplier Commodity Inspection',
            render: (value) => value ? 'Y' : 'N'
        },
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} toolbar={(
                <Space>
                    <Button type={'primary'} onClick={() => setImportModalVisible(true)}>Import</Button>
                    <Button type={'primary'} onClick={() => update()}>Update</Button>
                </Space>
            )}/>
            <UploadModal title={'Import Outsourcing Product'}
                         template={'/template/outsourcingProduct.xlsx'}
                         confirmLoading={onImporting}
                         onUpload={onImport}
                         visible={importModalVisible}
                         onCancel={() => setImportModalVisible(false)}/>
        </PageHeaderLayout>
    )
}

export default ProductOutside
